// extracted by mini-css-extract-plugin
module.exports = {"Root":"WidgetIcon_Root__1uDon"};